module.exports = __webpack_public_path__ + "img/explain_2.53a0af5c.png";